import React, { useState } from "react";
import { useRouteMatch } from "react-router-dom";

import { GET_EVENTS } from 'graphql/query/event-gql';

import GraphicStorage from 'components/graphic-storage';
import Events from 'components/events';
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables } from "components/layout";
import { Localize } from "components/service";
import { gqlBuilderWhere } from "utils";


const basePath = GraphicStorage.Const.basePath;
const tableHelper = GraphicStorage.Helpers.TableMain;


const GraphicStoragePage = () => {

    useActiveMenuItem([ "graphic-storage-main" ], [ "graphic-storage" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Exhibitions" }).props.children,
            path: `${ basePath }`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    let match = useRouteMatch(`${ basePath }/page/:pageNum`);

    const [ searchText, setSearchText ] = useState("");
    const [ filters, setFilters ] = useState();

    const filterTableName = 'graphicStorageFilters';
    const graphicStorageFilters = JSON.parse(localStorage.getItem(filterTableName));


    return (
        <PageWrapDefault
            className="page-graphic-storage"
            dataExist={ true }
            title={ <Localize>PAGES.Title_Exhibitions</Localize> }
        >
            <Tables.Main
                model="exhibitionEvents"
                query={ GET_EVENTS }
                varSet={ { perPage: 30 } }
                routeUrl={ `${ basePath }` }
                currentPage={ match ? parseInt(match.params.pageNum) : 1 }
                searchText={ searchText }
                objFilter={ filters || gqlBuilderWhere(graphicStorageFilters) }
                tableHelper={ tableHelper }
            >
                <div className="table-action-bar">

                    <div className="col">
                        <Events.Filters.Table
                            setSearchText={ setSearchText }
                            setFilters={ setFilters }
                            filters={ filters }
                            eventsFilters={ graphicStorageFilters }
                            filterTableName={ filterTableName } />
                    </div>

                    <div className="col">

                    </div>
                </div>

            </Tables.Main>
        </PageWrapDefault>
    )
};

export default GraphicStoragePage;
